// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oF8U","index":"styles_index__2xm2A"};